import React from "react"
import { Typography, Box } from "@mui/material"
import { ChevronLeft, Phone, Language, Twitter, Facebook, Instagram, LocationOn } from "@mui/icons-material"
import Chip from "../chips/Chip"
import type { PlaceDetailsPanelProps } from "../../types"
import "./styles/PlaceDetails.scss"

const PlaceDetails: React.FC<PlaceDetailsPanelProps> = ({ place, onClose }) => {
  if (!place) return null

  const {
    name,
    categories = [],
    vibes = [],
    address,
    telephone,
    website,
    url,
    twitter,
    facebook,
    instagram,
    image,
    vibemap_images,
    description,
    short_description,
    text_full,
  } = place.properties

  const displayImage = image || (vibemap_images && vibemap_images[0])
  const primaryCategory = categories?.[0]?.name || ""
  const displayDescription = description || short_description || text_full

  const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

  return (
    <div className="place-details">
      <Box className="header" mb={3}>
        <Box display="flex" alignItems="center" mb={1} onClick={onClose} style={{ cursor: "pointer" }}>
          <ChevronLeft className="back-icon" />
          <Typography variant="subtitle2" className="category-text">
            {capitalize(primaryCategory)}
          </Typography>
        </Box>
        <Typography variant="h1" component="h1" className="title">
          {name}
        </Typography>
      </Box>

      {displayImage && (
        <Box mb={2}>
          <img src={displayImage} alt={name} className="main-image" />
        </Box>
      )}

      {vibes.length > 0 && (
        <Box mb={2} display="flex" gap={1} flexWrap="wrap">
          {vibes.map((vibe) => (
            <Chip key={vibe.id} id={vibe.id} text={vibe.name} size="small" />
          ))}
        </Box>
      )}

      {displayDescription && (
        <Box mb={3}>
          <Typography variant="body1" className="description">
            {displayDescription}
          </Typography>
        </Box>
      )}

      <Typography variant="h3" component="h3" className="section-title" mb={2}>
        Plan Your Visit
      </Typography>

      <Box className="details-section">
        <Typography variant="body1" mb={2}>
          {capitalize(primaryCategory)}
        </Typography>

        <Typography variant="body1" mb={2}>
          Hours Placeholder
        </Typography>

        <Box className="contact-details">
          {address && (
            <a href={`https://maps.google.com/?q=${encodeURIComponent(address)}`} target="_blank" rel="noopener noreferrer" className="detail-link">
              <LocationOn />
              <span>{address}</span>
            </a>
          )}

          {(website || url) && (
            <a href={website || url} target="_blank" rel="noopener noreferrer" className="detail-link">
              <Language />
              <span>{website || url}</span>
            </a>
          )}

          {telephone && (
            <a href={`tel:${telephone.replace(/[^0-9]/g, "")}`} className="detail-link">
              <Phone />
              <span>{telephone}</span>
            </a>
          )}

          {twitter && (
            <a href={twitter} target="_blank" rel="noopener noreferrer" className="detail-link">
              <Twitter />
              <span>Twitter</span>
            </a>
          )}

          {facebook && (
            <a href={facebook} target="_blank" rel="noopener noreferrer" className="detail-link">
              <Facebook />
              <span>Facebook</span>
            </a>
          )}

          {instagram && (
            <a href={instagram} target="_blank" rel="noopener noreferrer" className="detail-link">
              <Instagram />
              <span>Instagram</span>
            </a>
          )}
        </Box>
      </Box>
    </div>
  )
}

export default PlaceDetails
